/**
 * Clean up the data from the NotaryForm.
 *
 * @param {Object} notaryData - The state object from the NotaryForm.
 * @param {Array} properties - Additional properties to be removed from data.
 * @return {Object} - Return the cleaned notary data.
 */
export default function cleanseNotaryData(notaryData, properties = []) {
  const defaultPropertiesToRemove = [
    'applicationStatus',
    'applicationStatusIsUpdated',
    'disableFields',
    'validateFields',
    'validateForm'
  ];

  if (!notaryData.id) {
    defaultPropertiesToRemove.push('id');
  }

  const propertiesToRemove = defaultPropertiesToRemove.concat(properties);
  propertiesToRemove.forEach((property) => delete notaryData[property]);

  return notaryData;
}
